class API {
  constructor() {
    this.url =
      "https://script.google.com/macros/s/AKfycbxXlzfqWSZw0qEzKoxX9vbokxdcqsy-uCm3DBVefGAXRmnEgMlbsuTKSXJ7W2xX7afIug/exec";
  }

  async push(feedbackData) {
    const data = JSON.stringify(feedbackData);

    return fetch(this.url, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    });
  }
}

export default API;
